// Google Analytics 4 — SPA route tracking.
//
// The base gtag.js tag is installed exactly once, globally, in public/index.html
// (configured with send_page_view:false). This module only sends the manual
// page_view events for real SPA route changes, deduped against React rerenders /
// StrictMode. No contact-form contents or personally identifiable information are
// ever sent to Analytics.

let lastTrackedUrl = null;

export function trackPageView() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  const url = window.location.pathname + window.location.search;
  if (url === lastTrackedUrl) return; // prevent duplicate page_view on rerenders
  lastTrackedUrl = url;

  window.gtag("event", "page_view", {
    page_path: url,
    page_location: window.location.href,
    page_title: document.title,
  });
}
